import { render } from "./HomePart3.vue?vue&type=template&id=1067c109&scoped=true&ts=true"
import script from "./HomePart3.vue?vue&type=script&lang=ts"
export * from "./HomePart3.vue?vue&type=script&lang=ts"

import "./HomePart3.vue?vue&type=style&index=0&id=1067c109&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1067c109"]])

export default __exports__